module.exports = __webpack_public_path__ + "static/Samuel Romero-64939e71fabbce94997d90ec5ef558c4.jpg";